// extracted by mini-css-extract-plugin
module.exports = {"dropTriggerIcon":"dropdown_dropTriggerIcon__j2-_8","dropdownMenu":"dropdown_dropdownMenu__23EXJ"};